import React from 'react'
import { BiMessageAltError } from 'react-icons/bi'
import { Button } from 'src/components/Common/Button'
import { FaUserAlt } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { Plans } from 'src/components/Home/Plans'
import { useIsIOSPlatform } from 'src/context/PlatformContext'
import { isIOS } from 'src/utils/platform'
import { Box } from './styles'

interface LessonPrivateProps {
  showPlans: boolean
}

const LessonPrivate: React.FC<LessonPrivateProps> = props => {
  const { t } = useTranslation()
  const iosFromContext = useIsIOSPlatform()
  const platformIsIOS = iosFromContext || isIOS()

  return (
    <Box>
      <div className="content">
        {!props.showPlans && (
          <>
            <div className="info">
              <BiMessageAltError className="icon" />
              <h2>{t('classroom.lessonPrivate.title')}</h2>
              <p>{t('classroom.lessonPrivate.subTitle')}</p>
            </div>

            <Button
              type="button"
              isLink
              href="/login"
              labelTx="header.login"
              preset="secondary"
              className="button-login"
              LeftAccessory={<FaUserAlt className="icon-login" />}
            />
          </>
        )}

        {props.showPlans && !platformIsIOS && <Plans showFeatures={false} isIOSDevice={false} />}
      </div>
    </Box>
  )
}

export default LessonPrivate
